export const TABLE_BACKGROUNDS = {
  teams: '',
  leads: '',
  contacts: '',
  documents: '',
  dashboard: '',
  orders: '',
  accounts: '',
  inventory: ''
};
